/**
 * Server validation error.
 */
export class ServerValidationError extends Error {
  constructor(response) {
    super(response.data && response.data.message ? response.data.message : response.statusText);
    this.validationErrors = response.data.errors || [];
    this.data = response.data;
  }
}

/**
 * For all other cases, when server replies with error.
 */
export class ServerError extends Error {
  constructor(response) {
    super('Oops. Something went wrong. Please try again later.');
    this.data = response.data;
  }
}
